import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref } from "vue"

const _hoisted_1 = { class: "location-addresses-list users" }
const _hoisted_2 = ["onChange"]
const _hoisted_3 = {
  id: "users",
  class: "d-flex a-i-center"
}
const _hoisted_4 = ["id", "checked", "disabled"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "d-flex a-i-end j-content-s-be w-100 ml-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "btn-pluse" }, null, -1)
const _hoisted_9 = { class: "text-raleway-11 text-center w-100" }
const _hoisted_10 = { class: "d-flex a-i-end j-content-center w-100 mr-1 ml-1" }
const _hoisted_11 = { class: "text-raleway-11" }
const _hoisted_12 = { class: "d-flex a-i-end j-content-center w-100 mr-1 ml-1" }
const _hoisted_13 = { class: "text-raleway-11" }

import { LocationsAccountsDetails } from "@/store/modules/accountDetails/type";
import { ResetFormType } from "@/store/modules/newOrders/type";
import { UserTypeOperation } from "@/store/modules/User/type";
import { computed, ref } from "vue";
import { IStore } from "@/store/types/StoreType";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'allUserComponent',
  props: {
    resetForm: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const store = useStore<IStore>();
const userData = ref(
  computed<UserTypeOperation[]>(() => store?.getters?.getAllUsers)
);

const select = ref(computed<number>(() => store?.getters?.getSelect));
const prevSelect = ref(computed<number>(() => store?.getters?.getPrevSelect));



const changeSelectUser = (userId: number) => {
  props.resetForm();
  store.commit("updateSelectUser", userId);
};

const deleteUser = () => {
  props.resetForm();
  store.dispatch("deleteUser", select.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userData.value, (user) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "pb-1 d-flex a-i-center",
          key: user?.id || 0,
          onChange: ($event: any) => (prevSelect.value === select.value && changeSelectUser(user?.id || -1))
        }, [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("input", {
              tabindex: 17,
              type: "radio",
              name: "select-scheldules_address no-select",
              class: _normalizeClass({ pointer: prevSelect.value === select.value }),
              id: 'radio' + user?.id,
              checked: select.value === user?.id,
              disabled: prevSelect.value !== select.value
            }, null, 10, _hoisted_4),
            _createElementVNode("label", {
              class: _normalizeClass(["text-motserrat-14 ml-1 no-select", { pointer: prevSelect.value === select.value }]),
              for: 'radio' + user?.id
            }, _toDisplayString(user?.first_name + " " + user?.last_name + " " + user?.email), 11, _hoisted_5)
          ], 512), [
            [_vShow, prevSelect.value && select.value && user?.first_name]
          ])
        ], 40, _hoisted_2))
      }), 128))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("div", {
        id: "add_user",
        class: "save-adresses-btn mt-2 d-flex a-i-center pointer no-select",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (changeSelectUser(-1)), ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("Add user")), 1)
        ])
      ], 512), [
        [_vShow, prevSelect.value === select.value && userData.value.length > 0]
      ]),
      _withDirectives(_createElementVNode("div", {
        id: "cancel_user",
        class: "save-adresses-btn mt-2 d-flex a-i-center pointer no-select",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (changeSelectUser(prevSelect.value)), ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("Cancel")), 1)
        ])
      ], 512), [
        [_vShow, prevSelect.value !== select.value]
      ]),
      _withDirectives(_createElementVNode("div", {
        id: "delete_user",
        class: _normalizeClass(["save-adresses-btn mt-2 d-flex a-i-center pointer ml-1 no-select", {
        'disabled-delete': _unref(store).state.TokenModuleOperation.userId === select.value,
      }]),
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
        _unref(store).state.TokenModuleOperation.userId !== select.value && deleteUser()
      ), ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("Delete")), 1)
        ])
      ], 2), [
        [_vShow, 
        prevSelect.value && select.value && prevSelect.value === select.value && userData.value.length > 0
      ]
      ])
    ], 512), [
      [_vShow, 
      userData.value[0]?.last_name &&
      userData.value[0]?.phone &&
      userData.value[0]?.first_name &&
      userData.value[0]?.email
    ]
    ])
  ], 64))
}
}

})